import React from "react";
import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useBrokerLandlords } from "services/hooks/rentals";
import BrokersLandlordsTable from "components/Tables/BrokersLandlordsTable";

const BrokerLandlords = () => {
  const role = useSelector((state) => state.role);
  const broker = useSelector((state) => state.broker);
  const isBroker = role === "broker";

  const brokerId = isBroker ? broker?.id : broker?.id;
  const { brokerLandlords, loadingBrokerLandlords, errorBrokerLandlords } = useBrokerLandlords(brokerId);

  if (!isBroker) {
    return (
      <Box m={2}>
        <Alert severity="warning">This page is for broker accounts only.</Alert>
      </Box>
    );
  }

  if (!brokerId) {
    return (
      <Box m={2}>
        <Alert severity="error">Broker profile not loaded. Try logging in again.</Alert>
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 2 }}>
        Assigned Landlords
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Landlords linked to your broker account and their commission rates.
      </Typography>
      <Paper sx={{ overflow: "hidden" }}>
        {loadingBrokerLandlords ? (
          <Box p={4} display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : errorBrokerLandlords ? (
          <Alert severity="error" sx={{ m: 2 }}>
            Failed to load assigned landlords.
          </Alert>
        ) : (
          <BrokersLandlordsTable
            brokerLandlords={brokerLandlords}
            loadingBrokerLandlords={loadingBrokerLandlords}
            errorBrokerLandlords={errorBrokerLandlords}
            showCommissionRate
          />
        )}
      </Paper>
    </Box>
  );
};

export default BrokerLandlords;
